import { BaseSizeEnum as i } from "./common.js";
const o = {
  [i.Small]: {
    iconSize: 16,
    buttonSize: 24
  },
  [i.Medium]: {
    iconSize: 24,
    buttonSize: 32
  },
  [i.Large]: {
    iconSize: 32,
    buttonSize: 40
  }
};
export {
  o as SIZE_MAP
};
//# sourceMappingURL=icon-button.js.map
